<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="rentForm"
          :model="rent"
          label-width="80px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('clean.serialNo')"
                  :prop="'serialNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateSerialNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="rent.serialNo"
                    :placeholder="$t('prompt.alphabetNumberLine')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('rent.serviceName')"
                  :prop="'serviceName'"
                >
                  <el-autocomplete
                    size="small"
                    v-model="rent.serviceName"
                    :fetch-suggestions="querySearchServiceNames"
                    style="width: 100%"
                    @select="handleSelectServiceName"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('rent.serviceAmount')"
                  :prop="'serviceAmount'"
                >
                  <el-input size="small" v-model.trim="rent.serviceAmount">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <el-input v-model="rent.remark" type="textarea" :rows="2" />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Rent from "@/api/rent.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {},
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("clean.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Rent.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.rent.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("clean.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      Util: Util,
      validateSerialNo: validateSerialNo,
      rent: {},
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    Rent.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.rent = res.data.entity;
        Vue.set(self.rent, "_rentAt", [
          new Date(self.rent.startAt),
          new Date(self.rent.endAt),
        ]);
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    // 服务商
    querySearchServiceNames(queryString, cb) {
      Rent.serviceNames().then(function (res) {
        const serviceNames = res.data.map((item) => {
          return { value: item };
        });
        cb(serviceNames);
      });
    },
    handleSelectServiceName(item) {},
    saveSubmit() {
      const self = this;
      self.$refs.rentForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          Rent.update(self.rent.id, self.rent).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.$emit("updateInfo", self.rent);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>